var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#0099D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.292 17.904C20.292 18.352 20.148 19.1253 19.86 20.224C19.572 21.312 19.428 22.0267 19.428 22.368C19.428 22.6987 19.476 22.864 19.572 22.864C19.636 22.864 19.8813 22.7627 20.308 22.56L20.5 22.464L20.772 23.024C20.676 23.1093 20.548 23.216 20.388 23.344C20.228 23.472 19.9293 23.648 19.492 23.872C19.0547 24.0853 18.6493 24.192 18.276 24.192C17.9027 24.192 17.6093 24.08 17.396 23.856C17.1827 23.6213 17.076 23.312 17.076 22.928C17.076 22.5333 17.2093 21.84 17.476 20.848C17.7427 19.8453 17.876 19.1947 17.876 18.896C17.876 18.448 17.7373 18.0267 17.46 17.632L17.316 17.44L17.332 17.232C17.8973 17.072 18.8147 16.992 20.084 16.992C20.2227 17.152 20.292 17.456 20.292 17.904ZM18.468 15.248C18.2547 15.0347 18.148 14.752 18.148 14.4C18.148 14.048 18.292 13.7387 18.58 13.472C18.8787 13.2053 19.22 13.072 19.604 13.072C19.988 13.072 20.2867 13.1787 20.5 13.392C20.7133 13.6053 20.82 13.888 20.82 14.24C20.82 14.5813 20.6653 14.8853 20.356 15.152C20.0573 15.4187 19.7213 15.552 19.348 15.552C18.9747 15.552 18.6813 15.4507 18.468 15.248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.104594b88813e72339e9ca43c4b071ce.svg";
export { ForwardRef as ReactComponent };